const AUTH_FILES = [
  'components',
  'general',
  'generalSettings',
  'login',
  'mfa',
  'resetPassword',
  'sessionLimit',
  'setNewPassword',
  'settings',
  'shopifySignup',
  'signup',
];

const loaders = import.meta.glob(
  '../../dashboard/i18n/locale/*/{components,general,generalSettings,login,mfa,resetPassword,sessionLimit,setNewPassword,settings,shopifySignup,signup}.json'
);

const localeFromPath = path => path.split('/locale/')[1].split('/')[0];

const hasLocale = locale =>
  Object.keys(loaders).some(path => localeFromPath(path) === locale);

async function loadLocaleMessages(locale) {
  const modules = await Promise.all(
    AUTH_FILES.map(file => {
      const load =
        loaders[`../../dashboard/i18n/locale/${locale}/${file}.json`];
      return load ? load() : null;
    })
  );

  return modules.reduce((messages, mod) => {
    if (mod?.default) Object.assign(messages, mod.default);
    return messages;
  }, {});
}

export async function loadAuthMessages(locale) {
  const requested = locale || 'en';
  const english = await loadLocaleMessages('en');

  if (requested === 'en' || !hasLocale(requested)) {
    return { en: english, [requested]: english };
  }

  const localized = await loadLocaleMessages(requested);
  return {
    en: english,
    [requested]: { ...english, ...localized },
  };
}
